import { createStyles, css } from 'antd-style';

export default createStyles(({ token }) => {
  return {
    configPage: css`
      max-width: 1200px;
      margin: 0 auto;
    `,
  };
});